module.exports = __webpack_public_path__ + "static/media/udemy.afa060ef.png";